import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'pt-loader-placeholder',
  templateUrl: './loader-placeholder.component.html',
  styleUrls: ['./loader-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, MatProgressSpinner],
})
export class LoaderPlaceholderComponent {
  @Input() placeholder: string;
  @Input() loadingPlaceholder = 'Loading...';
  @Input() loading = false;
}
